<mojo-widget [title]="widget.title" [showWidgetControls]="true" [widget]="widget">
  <ng-container widget-body *ngIf="loading">
    <p-progressSpinner></p-progressSpinner>
  </ng-container>
  <ng-container widget-body *ngIf="currentContact; else noData">
    <div class="contact-us-container full-container">
      <div [style.visibility]="loadingProfileImage ? 'hidden' : null"
        [ngClass]="{'fade-out': fadeOut, 'fade-in': !fadeOut}" class="contact-us-image"
        (mouseenter)="mouseEnterImage($event)" (mouseleave)="mouseLeaveOverlayOrImage($event)">
        <div [ngClass]="{'displayed': displayOverlay && currentContact.ManagerProfile}"
          (mouseleave)="mouseLeaveOverlayOrImage($event)" class="contact-us-overlay">
          <div class="contact-us-overlay-details">
            <div class="contact-us-overlay-manager-profile">{{currentContact.ManagerProfile}}</div>
          </div>
        </div>
        <img *ngIf="profileImageExists;else noProfileImage" [style.background-image]="imageUrl() | secureImage : true"
          [ngClass]="{'overlay-displayed': displayOverlay}" />
        <ng-template #noProfileImage>
          <div class="placeholder">
            <i class="fa fa-user-circle" aria-hidden="true"></i>
          </div>
        </ng-template>
      </div>
      <div class="contact-us-detail-container">
        <div class="contact-us-navigator prev" *ngIf="hasMultipleContacts()">
          <div class="contact-us-navigator-button">
            <div class="contact-us-navigator-button-container">
              <div>
                <button (click)="prevContact()"><i class="fa fa-angle-left fa-3x"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div [ngClass]="{'fade-out': fadeOut, 'fade-in': !fadeOut}" class="contact-us-detail">
          <h1>{{currentContact.ManagerName}}</h1>
          <h2>{{currentContact.ManagerDescription}}</h2>
          <div class="contact-us-detail-items-wrapper">
            <div class="contact-us-detail-items">
              <ng-container *ngIf="showPhoneNumber() && currentContact.ManagerPhone">
                <div class="contact-us-detail-item">
                  <div class="contact-us-detail-item-name">t:</div>
                  <div class="contact-us-detail-item-value">
                    <a href="tel:{{currentContact.ManagerPhone}}">{{currentContact.ManagerPhone}}</a>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="currentContact.ManagerDirectPhone">
                <div class="contact-us-detail-item">
                  <div class="contact-us-detail-item-name">dd:</div>
                  <div class="contact-us-detail-item-value">
                    <a href="tel:{{currentContact.ManagerDirectPhone}}">{{currentContact.ManagerDirectPhone}}</a>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="currentContact.ManagerMobilePhone">
                <div class="contact-us-detail-item">
                  <div class="contact-us-detail-item-name">m:</div>
                  <div class="contact-us-detail-item-value">
                    <a href="tel:{{currentContact.ManagerMobilePhone}}">{{currentContact.ManagerMobilePhone}}</a>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="currentContact.ManagerEmail">
                <div class="contact-us-detail-item">
                  <div class="contact-us-detail-item-name">e:</div>
                  <div class="contact-us-detail-item-value">
                    <a href="mailto:{{currentContact.ManagerEmail}}">{{currentContact.ManagerEmail}}</a>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="contact-us-navigator next" *ngIf="hasMultipleContacts()">
          <div class="contact-us-navigator-button right">
            <div class="contact-us-navigator-button-container">
              <div>
                <button (click)="nextContact()" type="button"><i class="fa fa-angle-right fa-3x"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template widget-body #noData>
    <div class="contact-us-container full-container">
      <h3>No contact information</h3>
    </div>
  </ng-template>
</mojo-widget>